module.exports = __webpack_public_path__ + "static/media/copy_icon.bda46c00.svg";